import React from "react";

export const DistrictDetailContext = React.createContext(null);

export const useDistrictDetailContext = () => {
  const context = React.useContext(DistrictDetailContext);

  if (!context) throw new Error("District Detail Context not provided!");

  return context;
};
